'use client'

import { useEffect, useState } from 'react'

import { RotateCcw } from 'lucide-react'
import ReactPlayer from 'react-player'

interface VideoPlayerProps {
  url: string
}

export const VideoPlayer = ({ url }: VideoPlayerProps) => {
  const [isClient, setIsClient] = useState(false)
  const [hasEnded, setHasEnded] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return isClient ? (
    hasEnded ? (
      <div
        onClick={() => setHasEnded(false)}
        className="group relative flex aspect-video h-auto w-full cursor-pointer items-center justify-center bg-black xl:h-[600px] xl:w-auto"
      >
        <RotateCcw className="size-16 text-white transition-transform duration-300 ease-in-out group-hover:scale-125" />
      </div>
    ) : (
      <div className="z-1 relative aspect-video h-auto w-full overflow-hidden xl:h-[600px] xl:w-auto">
        <ReactPlayer
          className="object-cover"
          url={url}
          playing
          onEnded={() => setHasEnded(true)}
          width="100%"
          height="100%"
          config={{
            youtube: {
              playerVars: {
                playlist: url.split('v=')[1],
                muted: 0,
                autoplay: 1,
                controls: 1,
                modestbranding: 1,
                rel: 0,
                showinfo: 0,
                iv_load_policy: 3,
                disablekb: 0,
                fs: 0,
              },
            },
          }}
        />
      </div>
    )
  ) : (
    <div />
  )
}
